import { fileService } from 'api/services/file'
import { Wrapper } from 'components'
import { useContext } from 'react'
import { AuthContext } from 'contexts/AuthContext'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'keep-react'
import { Download, Eye } from 'phosphor-react'
import { useEffect, useState } from 'react'

type SettingFile = {
  identifier: string
  type: string
  file: string
}

export const Documents = () => {
  const [settingFiles, setSettingFiles] = useState<SettingFile[] | null>(null)
  const { currentBroker } = useContext(AuthContext)

  const getFiles = async () => {
    try {
      const fichaNomeacao = await fileService.getFilesFromAzure({
        identifier: 'ficha_nomeacao',
        type: 'settings',
      })
      const autorizacaoDebitoDirecto = await fileService.getFilesFromAzure({
        identifier: 'autorizacao_debito_directo',
        type: 'settings',
      })
      const formularioDeSinistros = await fileService.getFilesFromAzure({
        identifier: 'formulario_de_sinistros',
        type: 'settings',
      })
      const comprovativoIbanInnovarisk = await fileService.getFilesFromAzure({
        identifier: 'comprovativo_de_iban_innovarisk',
        type: 'settings',
      })
      const declaracaoAusenciaSinistro = await fileService.getFilesFromAzure({
        identifier: 'declaracao_de_ausencia_de_sinistro',
        type: 'settings',
      })
      setSettingFiles([
        ...(fichaNomeacao.length > 0
          ? [
              {
                identifier: 'ficha_nomeacao',
                type: 'settings',
                file: fichaNomeacao[0].uri,
              },
            ]
          : []),
        ...(autorizacaoDebitoDirecto.length > 0
          ? [
              {
                identifier: 'autorizacao_debito_directo',
                type: 'settings',
                file: autorizacaoDebitoDirecto[0].uri,
              },
            ]
          : []),
        ...(formularioDeSinistros.length > 0
          ? [
              {
                identifier: 'formulario_de_sinistros',
                type: 'settings',
                file: formularioDeSinistros[0].uri,
              },
            ]
          : []),
        ...(comprovativoIbanInnovarisk.length > 0
          ? [
              {
                identifier: 'comprovativo_de_iban_innovarisk',
                type: 'settings',
                file: comprovativoIbanInnovarisk[0].uri,
              },
            ]
          : []),
        ...(declaracaoAusenciaSinistro.length > 0
          ? [
              {
                identifier: 'declaracao_de_ausencia_de_sinistro',
                type: 'settings',
                file: declaracaoAusenciaSinistro[0].uri,
              },
            ]
          : []),
      ])
    } catch (error) {
      // toast.error('Não foi possível carregar os ficheiros de configuração.')
    }
  }

  useEffect(() => {
    getFiles()
  }, [])

  return (
    <div className="w-full flex-1 py-12">
      <Wrapper>
        <div className="lg:pt-8">
          <h2 className="uppercase text-sm font-medium text-blue-900">
            Documentos
          </h2>
          <h1
            className={`pb-10 text-xxxl font-medium ${currentBroker?.IsPrimePartner ? 'text-prime' : 'text-primary-600'}`}
          >
            Descarregue documentos
          </h1>

          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>
                  <div>Documento</div>
                </TableHead>
                <TableHead></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {settingFiles?.find(
                s => s.identifier === 'autorizacao_debito_directo',
              ) && (
                <TableRow>
                  <TableCell>Autorização de Debito Directo</TableCell>
                  <TableCell>
                    <div className="flex items-center justify-end gap-4">
                      <a
                        href={
                          settingFiles?.find(
                            s => s.identifier === 'autorizacao_debito_directo',
                          )?.file
                        }
                        target="blank"
                      >
                        <Eye
                          size={24}
                          className="text-metal-400 duration-300 hover:text-metal-900"
                        />
                      </a>
                      <a
                        href={
                          settingFiles?.find(
                            s => s.identifier === 'autorizacao_debito_directo',
                          )?.file
                        }
                        target="blank"
                        download
                      >
                        <Download
                          size={24}
                          className="text-metal-400 duration-300 hover:text-metal-900"
                        />
                      </a>
                    </div>
                  </TableCell>
                </TableRow>
              )}

              {settingFiles?.find(
                s => s.identifier === 'formulario_de_sinistros',
              ) && (
                <TableRow>
                  <TableCell>Formulário de Sinistros</TableCell>
                  <TableCell>
                    <div className="flex items-center justify-end gap-4">
                      <a
                        href={
                          settingFiles?.find(
                            s => s.identifier === 'formulario_de_sinistros',
                          )?.file
                        }
                        target="blank"
                      >
                        <Eye
                          size={24}
                          className="text-metal-400 duration-300 hover:text-metal-900"
                        />
                      </a>
                      <a
                        href={
                          settingFiles?.find(
                            s => s.identifier === 'formulario_de_sinistros',
                          )?.file
                        }
                        target="blank"
                        download
                      >
                        <Download
                          size={24}
                          className="text-metal-400 duration-300 hover:text-metal-900"
                        />
                      </a>
                    </div>
                  </TableCell>
                </TableRow>
              )}

              {settingFiles?.find(
                s => s.identifier === 'comprovativo_de_iban_innovarisk',
              ) && (
                <TableRow>
                  <TableCell>Comprovativo de IBAN Innovarisk</TableCell>
                  <TableCell>
                    <div className="flex items-center justify-end gap-4">
                      <a
                        href={
                          settingFiles?.find(
                            s =>
                              s.identifier ===
                              'comprovativo_de_iban_innovarisk',
                          )?.file
                        }
                        target="blank"
                      >
                        <Eye
                          size={24}
                          className="text-metal-400 duration-300 hover:text-metal-900"
                        />
                      </a>
                      <a
                        href={
                          settingFiles?.find(
                            s =>
                              s.identifier ===
                              'comprovativo_de_iban_innovarisk',
                          )?.file
                        }
                        target="blank"
                        download
                      >
                        <Download
                          size={24}
                          className="text-metal-400 duration-300 hover:text-metal-900"
                        />
                      </a>
                    </div>
                  </TableCell>
                </TableRow>
              )}
              {settingFiles?.find(
                s => s.identifier === 'declaracao_de_ausencia_de_sinistro',
              ) && (
                <TableRow>
                  <TableCell>Declaração de Ausência de Sinistro</TableCell>
                  <TableCell>
                    <div className="flex items-center justify-end gap-4">
                      <a
                        href={
                          settingFiles?.find(
                            s =>
                              s.identifier ===
                              'declaracao_de_ausencia_de_sinistro',
                          )?.file
                        }
                        target="blank"
                      >
                        <Eye
                          size={24}
                          className="text-metal-400 duration-300 hover:text-metal-900"
                        />
                      </a>
                      <a
                        href={
                          settingFiles?.find(
                            s =>
                              s.identifier ===
                              'declaracao_de_ausencia_de_sinistro',
                          )?.file
                        }
                        target="blank"
                        download
                      >
                        <Download
                          size={24}
                          className="text-metal-400 duration-300 hover:text-metal-900"
                        />
                      </a>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </Wrapper>
    </div>
  )
}
